module.exports = __webpack_public_path__ + "img/on-demand-white.ab28ee5c.svg";